import {
  Banknote,
  CircleAlert,
  Clock,
  CreditCard,
  HandPlatter,
  Headset,
  History,
  ShoppingCart,
  Users,
  Utensils,
  ScanQrCode,
  Smartphone,
} from "lucide-react";
export const Config = {
  env: {
    app: {
      support_email: import.meta.env.VITE_SUPPORT_EMAIL,
      sentry: {
        dsn: import.meta.env.VITE_SENTRY_DSN,
        auth_token: import.meta.env.VITE_SENTRY_AUTH_TOKEN,
        org: import.meta.env.VITE_SENTRY_ORG,
        project: import.meta.env.VITE_SENTRY_PROJECT,
      },
      token: import.meta.env.VITE_RESTAURANT_TOKEN,
      api_url: import.meta.env.VITE_API_URL,
      image_url: import.meta.env.VITE_IMAGE_URL,
      stipe_public_key: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
      sso_api_url: import.meta.env.VITE_SSO_API_URL,
      sso_url: import.meta.env.VITE_SSO_URL,
      sso_cookie_domain: import.meta.env.VITE_SSO_COOKIE_DOMAIN,
      google_map_key: import.meta.env.VITE_GOOGLE_MAP_KEY,
      recaptcha_key: import.meta.env.VITE_RECAPTCHA_KEY,
      languages: [
        {
          label: "languages.german",
          value: "de",
          image: `${import.meta.env.VITE_IMAGE_URL}/languages/germany.png`,
        },
        {
          label: "languages.english",
          value: "en",
          image: `${import.meta.env.VITE_IMAGE_URL}/languages/usa.png`,
        },
      ],
      header: [
        {
          title: "header.cart",
          href: "cart",
          icon: ShoppingCart,
        },
      ],
      aside: [
        {
          title: "header.menu",
          href: "menu",
          icon: Utensils,
        },
        {
          title: "header.history",
          href: "history",
          icon: History,
        },
        {
          title: "header.about",
          href: "about",
          icon: CircleAlert,
        },
      ],
      sidebar: [
        {
          title: "header.menu",
          href: "menu",
          icon: Utensils,
        },
        {
          title: "header.about",
          href: "about",
          icon: CircleAlert,
        },
        {
          title: "header.cart",
          href: "cart",
          icon: ShoppingCart,
        },
        {
          title: "header.history",
          href: "history",
          icon: History,
        },
      ],
      country_code: [
        {
          name: "Austria",
          code: "AT",
          emoji: "🇦🇹",
          unicode: "U+1F1E6 U+1F1F9",
          label: "+43",
          value: "+43",
          image:
            "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg",
        },
        {
          name: "Germany",
          code: "DE",
          emoji: "🇩🇪",
          unicode: "U+1F1E9 U+1F1EA",
          label: "+49",
          value: "+49",
          image:
            "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg",
        },
        {
          name: "Liechtenstein",
          code: "LI",
          emoji: "🇱🇮",
          unicode: "U+1F1F1 U+1F1EE",
          label: "+423",
          value: "+423",
          image:
            "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg",
        },
        {
          name: "Switzerland",
          code: "CH",
          emoji: "🇨🇭",
          unicode: "U+1F1E8 U+1F1ED",
          label: "+41",
          value: "+41",
          image:
            "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg",
        },
      ],
      ordering_method: [
        {
          label: "cart.ordering_method.options.pickup",
          value: "pickup",
        },
        {
          label: "cart.ordering_method.options.delivery",
          value: "delivery",
        },
        {
          label: "cart.ordering_method.options.in_restaurant",
          value: "table_reservation",
        },
        {
          label: "cart.ordering_method.options.in_restaurant_and_pre_order",
          value: "in_restaurant",
        },
        {
          label: "cart.ordering_method.options.dine_in",
          value: "dine_in",
        },
      ],
      ordering_method_history: [
        {
          label: "cart.ordering_method.options.all",
          value: "all",
        },
        {
          label: "cart.ordering_method.options.pickup",
          value: "pickup",
        },
        {
          label: "cart.ordering_method.options.delivery",
          value: "delivery",
        },
        {
          label: "cart.ordering_method.options.in_restaurant",
          value: "table_reservation",
        },
        {
          label: "cart.ordering_method.options.in_restaurant_and_pre_order",
          value: "in_restaurant",
        },
        {
          label: "cart.ordering_method.options.dine_in",
          value: "dine_in",
        },
      ],
      ordering_method_header: [
        {
          label: "cart.ordering_method.options.pickup",
          value: "pickup",
        },
        {
          label: "cart.ordering_method.options.delivery",
          value: "delivery",
        },
        {
          label: "cart.ordering_method.options.in_restaurant_and_pre_order",
          value: "in_restaurant",
        },
      ],
      ordering_method_type: [
        {
          icon: Clock,
          title: "cart.available_time_choice.title",
          value: "pickup",
        },
        {
          icon: Clock,
          title: "cart.available_time_choice.title",
          value: "delivery",
        },
        {
          icon: Users,
          title: "cart.table_size.title",
          value: "table_reservation",
        },
        {
          icon: Users,
          title: "cart.table_size.title",
          value: "in_restaurant",
        },
        {
          icon: HandPlatter,
          title: "cart.table_number.title",
          value: "dine_in",
        },
      ],
      about_ordering_method: [
        {
          title: "cart.ordering_method.options.pickup",
          value: "pickup",
        },
        {
          title: "cart.ordering_method.options.delivery",
          value: "delivery",
        },
        {
          title: "cart.ordering_method.options.dine_in",
          value: "dine_in",
        },
        {
          title: "cart.ordering_method.options.in_restaurant",
          value: "reservation",
        },
      ],
      online_payment_methods: [
        {
          value: "card",
          image: "/images/online-payments/card.svg",
        },
        {
          value: "twint",
          image: "/images/online-payments/twint.svg",
        },
        {
          value: "paypal",
          image: "/images/online-payments/paypal.svg",
        },
        {
          value: "google-pay",
          image: "/images/online-payments/google-pay.svg",
        },
        {
          value: "apple-pay",
          image: "/images/online-payments/apple-pay.svg",
        },
        // {
        //   value: "revolut",
        //   image: "/images/online-payments/revolut.svg",
        // },
      ],
      pickup_method: [
        {
          label: "cart.available_time_choice.form.as_soon_as_possible",
          value: "as_soon_as_possible",
        },
        {
          label: "cart.available_time_choice.form.later",
          value: "later",
        },
      ],
      ordering_method_sub_type: [
        {
          icon: CreditCard,
          title: "cart.payment_method.title",
          value: "pickup",
        },
        {
          icon: CreditCard,
          title: "cart.payment_method.title",
          value: "delivery",
        },
        {
          icon: Clock,
          title: "cart.available_time_choice.title",
          value: "table_reservation",
        },
        {
          icon: Clock,
          title: "cart.available_time_choice.title",
          value: "in_restaurant",
        },
        {
          icon: CreditCard,
          title: "cart.payment_method.title",
          value: "dine_in",
        },
      ],
      payment_method: [
        {
          label: "cart.payment_method.form.cash",
          value: "cash",
          color:
            "inline-flex items-center rounded-full bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10",
          icon: Banknote,
        },
        {
          label: "cart.payment_method.form.card",
          value: "card",
          color:
            "inline-flex items-center rounded-full bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10",
          icon: CreditCard,
        },
        {
          label: "cart.payment_method.form.call_me_back",
          value: "call_me_back",
          color:
            "inline-flex items-center rounded-full bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10",
          icon: Headset,
        },
        // {
        //   label: "cart.payment_method.form.qr_code_scan",
        //   value: "qr_code_scan",
        //   color:
        //     "inline-flex items-center rounded-full bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10",
        //   icon: ScanQrCode,
        // },
        {
          label: "cart.payment_method.form.pay_online",
          value: "pay_online",
          color:
            "inline-flex items-center rounded-full bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10",
          icon: Smartphone,
        },
      ],
      order_type_custom: [
        {
          label: "Pick-up",
          value: "pickup",
        },
        {
          label: "Order Ahead",
          value: "in_restaurant",
        },
        {
          label: "Delivery",
          value: "delivery",
        },
        {
          label: "Dine-in",
          value: "dine_in",
        },
      ],
      type: [
        { label: "order_history.form.type_options.email", value: "email" },
        {
          label: "order_history.form.type_options.telephone",
          value: "telephone",
        },
      ],
      order_status: [
        {
          label: "order_status.pending",
          value: "pending",
          color:
            "rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20",
        },
        {
          label: "order_status.accepted",
          value: "accepted",
          color:
            "rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20",
        },
        {
          label: "order_status.preparing",
          value: "preparing",
          color:
            "rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20",
        },
        {
          label: "order_status.ready_for_pickup",
          value: "ready_for_pickup",
          color:
            "rounded-full bg-purple-50 px-2 py-1 text-xs font-medium text-purple-800 ring-1 ring-inset ring-purple-600/20",
        },
        {
          label: "order_status.ready_for_delivery",
          value: "ready_for_delivery",
          color:
            "rounded-full bg-purple-50 px-2 py-1 text-xs font-medium text-purple-800 ring-1 ring-inset ring-purple-600/20",
        },
        {
          label: "order_status.ready",
          value: "ready",
          color:
            "rounded-full bg-purple-50 px-2 py-1 text-xs font-medium text-purple-800 ring-1 ring-inset ring-purple-600/20",
        },
        {
          label: "order_status.picked_up",
          value: "picked_up",
          color:
            "rounded-full bg-purple-50 px-2 py-1 text-xs font-medium text-purple-800 ring-1 ring-inset ring-purple-600/20",
        },
        {
          label: "order_status.delivered",
          value: "delivered",
          color:
            "rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-800 ring-1 ring-inset ring-green-600/20",
        },
        {
          label: "order_status.rejected",
          value: "rejected",
          color:
            "rounded-full bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10",
        },
        {
          label: "order_status.completed",
          value: "completed",
          color:
            "rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20",
        },
        {
          label: "order_status.cancelled",
          value: "cancelled",
          color:
            "rounded-full bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10",
        },
        {
          label: "order_status.missed",
          value: "missed",
          color:
            "rounded-full bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10",
        },
      ],
      manage_seating_options: [
        {
          label: "cart.seating_preference.options.indoor_only",
          value: "indoor_only",
        },
        {
          label: "cart.seating_preference.options.outdoor_only",
          value: "outdoor_only",
        },
        {
          label: "cart.seating_preference.options.both_indoor_and_outdoor",
          value: "both_indoor_and_outdoor",
        },
        {
          label: "cart.seating_preference.options.not_applicable",
          value: "not_applicable",
        },
      ],
    },
  },
};
